<script>
	import ContactWithDoB from "../../components/ContactWithDoB.svelte";
	import Input from "../../components/Input.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { anonymousId } from "../../analytics";
	import { pageNumber, model } from "../../stores";
	import { referralTypes } from "../../config";
	import registrationTypes from "../../config/registrationTypes";
	import { getTealiumID } from "../../tealium";

	export let disabled = null;
	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	let required = true;

	let mainContactName = "Main Contact";
	$: {
		if ($model.Contact.FirstName && $model.Contact.Surname) {
			mainContactName = `${$model.Contact.FirstName} ${$model.Contact.Surname}`;
		} else if ($model.Contact.FirstName) {
			mainContactName = $model.Contact.FirstName;
		} else if ($model.Contact.Surname) {
			mainContactName = $model.Contact.Surname;
		} else {
			mainContactName = "Main Contact";
		}
	}

	const sameContactDetails = () => {
		$model.Claimant.PhoneNumber = $model.Contact.PhoneNumber;
		$model.Claimant.EmailAddress = $model.Contact.EmailAddress;
		Object.keys($model.Contact.Address).forEach((key, i) => {
			$model.Claimant.Address[key] = $model.Contact.Address[key];
		});
	};

	if (!disabled) {
		pageNumber.update((p) => pageIndex);
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		if (typeof window !== "undefined" && window.analytics && window.analytics.user) {
			$model.RegistrationSegmentId = anonymousId();
		}

		$model.TealiumId = getTealiumID();
	}

	const initialise = () => {
		console.log($model);
	};

	initialise();
</script>

<PageSection>
	<h2>Your Contact Details</h2>
	<ContactWithDoB
		bind:title={$model.Contact.Title}
		bind:firstName={$model.Contact.FirstName}
		bind:surname={$model.Contact.Surname}
		bind:dateOfBirth={$model.Contact.DateOfBirth}
		bind:emailAddress={$model.Contact.EmailAddress}
		bind:phoneNumber={$model.Contact.PhoneNumber}
		bind:address={$model.Contact.Address}
		idPrefix="contact"
		{required}
		{disabled}
	></ContactWithDoB>

	<FormRow>
		<FormColumn cols="8">
			<label for="registrationType" class:isrequired={required}>Who are you registering on behalf of?</label>
			<Select
				{required}
				{disabled}
				id="registrationType"
				bind:value={$model.RegistrationType}
				optionList={registrationTypes.options}
				textProperty="name"
				valueProperty="value"
			></Select>
		</FormColumn>
		{#if $model.RegistrationType === registrationTypes.types.Other.value}
			<FormColumn cols="4">
				<Input
					{required}
					{disabled}
					bind:value={$model.RelationshipToClaimant}
					maxLength="100"
					id="otherRegistrationType"
					label="If Other, please specify"
				/>
			</FormColumn>
		{/if}
	</FormRow>

	{#if $model.RegistrationType && $model.RegistrationType !== registrationTypes.types.Myself.value}
		<div class="form-row">
			<div class="col-md-6">
				<h2>Claimant Details</h2>
			</div>
			<div class="col-md-6 last">
				{#if !disabled}
					<button
						class="btn btn-primary btn-add-holdings btn-sm"
						on:click|preventDefault={() => sameContactDetails()}
						>Same contact details as {mainContactName}</button
					>
				{/if}
			</div>
		</div>

		<p>The person you enter in the fields below will be recorded as the claimant in the this class action.</p>
		<ContactWithDoB
			bind:title={$model.Claimant.Title}
			bind:firstName={$model.Claimant.FirstName}
			bind:surname={$model.Claimant.Surname}
			bind:dateOfBirth={$model.Claimant.DateOfBirth}
			bind:emailAddress={$model.Claimant.EmailAddress}
			bind:phoneNumber={$model.Claimant.PhoneNumber}
			bind:address={$model.Claimant.Address}
			idPrefix="claim"
			{required}
			{disabled}
		></ContactWithDoB>

		<FormRow>
			<FormColumn>
				<Checkbox
					id="auth"
					{disabled}
					required="true"
					bind:checked={$model.AuthorisedToAct}
					label="I am authorised to register on behalf of the Claimant"
				></Checkbox>
			</FormColumn>
		</FormRow>
	{/if}

	<FormRow>
		<div class="col-md-8 col-sm-12">
			<Checkbox
				{disabled}
				required="true"
				bind:checked={$model.PrivacyPolicyConfirmed}
				label="I agree to the Shine Lawyers <a href='https://www.shine.com.au/privacy-policy' title='Privacy Policy' target='_blank'>Privacy Policy</a>"
				id="privacy"
			></Checkbox>
		</div>
	</FormRow>

	<FormRow>
		<FormColumn>
			<label for="whereDidYouHear" class:isrequired={required}>Where did you hear about our firm?</label>
			<Select
				{required}
				{disabled}
				id="whereDidYouHear"
				bind:value={$model.WhereDidYouHear}
				optionList={referralTypes}
				textProperty="name"
				valueProperty="name"
			></Select>
		</FormColumn>
	</FormRow>

	{#if !disabled}
		<div class="form-group form-row">
			<div class="col-md-12 last">
				<NavigationButtons {persistUrl} {previousPage} {nextPage} pageName={title} tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	{/if}
</PageSection>

<style>
</style>
